import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Link } from '@sunrun/component-library';
import '@sunrun/component-library/dist/fonts.css';
import Splash from '../../layouts/Splash';
import MobileAppIcon from '../../images/MobileAppIcon';
import AnimationPlaceholder from '../../images/AnimationPlaceholder';
import AppleQRCode from '../../images/AppleQRCode';
import AndroidQRCode from '../../images/AndroidQRCode';
import AppleStoreDownload from '../../images/AppleStoreDownload';
import AndroidStoreDownload from '../../images/AndroidStoreDownload';

const StyledHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-bottom: 24px;
  max-width: 469px;

  div {
    color: white;
    font-family: 'Roobert', sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: -0.64px;
    line-height: 1.1;
    text-align: left;
  }
`;

const StyledParagraph = styled.div`
  align-items: center;
  align-self: center;
  color: white;
  display: flex;
  font-family: 'Roobert', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  justify-content: center;
  letter-spacing: -0.32px;
  line-height: 1.4;
  margin: 24px auto;
  max-width: 420px;
`;

const StyledSubHeader = styled.div`
  color: white;
  font-family: 'Roobert', sans-serif;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.4px;
  line-height: 1.2;
  margin: 0 auto 24px auto;
  max-width: 400px;
`;

const DownloadImages = styled.div`
  display: flex;
  gap: 40px;
  justify-content: center;
`;

const StyledLink = styled(Link)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const LoginInfo = () => {
  const { t } = useTranslation();
  return (
    <Splash useNewLogin>
      <StyledHeader>
        <MobileAppIcon />
        <div>{t('Our new mobile app is here!')}</div>
      </StyledHeader>
      <AnimationPlaceholder width="178px" height="360px" />
      <StyledParagraph>
        {t(
          // eslint-disable-next-line max-len
          'Newly designed and easy-to-use, our app is the single access point for you to monitor your system, track energy production, manage your account, and get support.',
        )}
      </StyledParagraph>
      <StyledSubHeader>{t('Download it today.')}</StyledSubHeader>
      <DownloadImages>
        <StyledLink data-testid="apple-store-link" href="https://apps.apple.com/us/app/sunrun/id6443806453">
          <AppleQRCode height="80px" width="80px" />
          <AppleStoreDownload />
        </StyledLink>
        <StyledLink data-testid="android-store-link" href="https://play.google.com/store/apps/details?id=com.sunrun.customerapp">
          <AndroidQRCode height="80px" width="80px" />
          <AndroidStoreDownload height="60px" width="154px" />
        </StyledLink>
      </DownloadImages>
    </Splash>
  );
};

export default LoginInfo;
